import React from "react"
import * as Icon from "react-feather"
//import FontAwesomeIcon from "react-fontawesome"
const optionsMenuConfig = [
  {
    id: "accidenttype",
    title: "Accident Types",
    type: "item",
    // icon: <Icon.AlertCircle size={20} />,
    icon:<Icon.PlusSquare size={20}/>,
    permissions: ["admin", "editor"],
    navLink: "/accidenttypes",

  },
  {
    id: "additionalflag",
    title: "Additional Flag",
    type: "item",
    // icon: <Icon.AlertCircle size={20} />,
    icon:<Icon.Flag size={20}/>,
    permissions: ["admin", "editor"],
    navLink: "/additionalflag",

  },
  {
    id: "addtionalstain",
    title: "Additional Stain",
    type: "item",
    // icon: <Icon.AlertCircle size={20} />,
    icon:<Icon.Cast size={20}/>,
    permissions: ["admin", "editor"],
    navLink: "/additionalstain",

  },
  {
    id: "ailmenttypes",
    title: "Ailment Types",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/ailmenttypes",

  },
  {
    id: "AdditionalReferringProviders",
    title: "Additional Referring Providers",
    type: "item",
    icon: <Icon.Inbox size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/AdditionalReferringProviders",

  },
  {
    id: "billingclass",
    title: "Billing Classes",
    type: "item",
    icon: <Icon.BarChart2 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/billingclasses",

  },
  {
    id: "commentlist",
    title: "Comments",
    type: "item",
    icon: <Icon.Lock size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/commentlist",

  },
  // {
  //   id: "caseunlock",
  //   title: "Case Unlock",
  //   type: "item",
  //   icon: <Icon.Lock size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/caselocked",

  // },
  {
    id: "cptcodelist",
    title: "CPT Code",
    type: "item",
    icon: <Icon.Droplet size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/cptcodelist",

  },
  {
    id: "mngdepartments",
    title: "Departments",
    type: "item",
    icon: <Icon.Package size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/departments",

  },
  {
    id: "p_ethinicity",
    title: "Ethinicity",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/Ethnicities",

  },
  {
    id: "financialclases",
    title: "Financial Classes",
    type: "item",
    icon: <Icon.DollarSign size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/financialclasses",

  },
  {
    id: "bodysites",
    title: "FISH Body Sites",
    type: "item",
    icon: <Icon.Eye size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/bodysites",

  },
  {
    id: "p_gender",
    title: "Gender",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/Genders",

  },
  {
    id: "gennotifieruser",
    title: "GenNotifier Users",
    type: "item",
    icon: <Icon.UserCheck size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/gennotifieruserlist",

  },
  {
    id: "grossdescription",
    title: "Gross Description",
    type: "item",
    icon: <Icon.Inbox size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/grossdescription",

  },
  {
    id: "HL7Compendium",
    title: "HL7 Compendium",
    type: "item",
    icon: <Icon.Circle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/hl7compendium",
   
  },
  {
    id: "HL7CompendiumFileUpload",
    title: "HL7 Compendium File Upload",
    type: "item",
    icon: <Icon.Circle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/hl7compendiumfileupload",
   
  },
  {
    id: "icdcodelist",
    title: "ICD Codes",
    type: "item",
    icon: <Icon.Link2 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/icdcodelist",

  },
  {
    id: "immunodeficiencydiagnosiscodes",
    title: "Immunodeficiency Diagnosis Codes",
    type: "item",
    icon: <Icon.Droplet size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/immunodeficiencydiagnosiscodes",

  },
  {
    id: "masterlist",
    title: "Master List",
    type: "item",
    icon: <Icon.Anchor size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/masterlist",

  },
  {
    id: "microcodes",
    title: "Microcodes",
    type: "item",
    icon: <Icon.Pocket size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/microcodes",

  },
  {
    id: "nucleiclassification",
    title: "Nuclei Classification",
    type: "item",
    icon: <Icon.Airplay size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/nucleiclassification",

  },
  {
    id: "pathologists",
    title: "Pathologists",
    type: "item",
    icon: <Icon.UserPlus size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/pathologists",

  },
  {
    id: "practice",
    title: "Practice",
    type: "item",
    icon: <Icon.Filter size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/practicelist",

  },
  {
    id: "probelots",
    title: "Probe Lots",
    type: "item",
    icon: <Icon.Filter size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/probelots",

  },
  {
    id: "probesets",
    title: "Probe Sets",
    type: "item",
    icon: <Icon.Image size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/probesets",

  },
  {
    id: "procedures",
    title: "Procedures/Body Sites",
    type: "item",
    icon: <Icon.Feather size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/procedurelist",

  },
  {
    id: "quick_result",
    title: "Quick Result",
    type: "item",
    icon: <Icon.LifeBuoy size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/QuickResult",

  },
  {
    id: "p_race",
    title: "Race",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/Races",

  },
  {
    id: "resultslist",
    title: "Results",
    type: "item",
    icon: <Icon.Codesandbox size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/resultslist",

  },
  {
    id: "relationship",
    title: "Relationship",
    type: "item",
    icon: <Icon.GitMerge size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/relationshiplist",

  },
  {
    id: "resultcategory",
    title: "Result Category",
    type: "item",
    icon: <Icon.Command size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/resultcategory",

  },
  {
    id: "rpTest",
    title: "Result Portal Test",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/ResultPortalTest",

  },
  {
    id: "sample_type",
    title: "Sample Type",
    type: "item",
    icon: <Icon.Type size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/SampleType",

  },
  {
    id: "screeners",
    title: "Screeners",
    type: "item",
    icon: <Icon.Sunrise size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/screeners",

  },
  {
        id: "specimenkitcollection",
        title: "Specimen Kit Detail",
        type: "item",
        icon: <Icon.Package size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/specimenkitcollection",
      },
    {
      id: "specimendetail",
      title: "Specimen Description Detail",
      type: "item",
      icon: <Icon.Command size={20} />,
      permissions: ["admin", "editor"],
      navLink: "/SpecimenDescriptionDetail",
  
    },
  {
    id: "p_sexual_orientation",
    title: "Sexual Orientation",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/SexualOrientation",

  },
  {
    id: "submittingfacility",
    title: "Submitting Facilities",
    type: "item",
    icon: <Icon.UploadCloud size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/submittingfacilities",

  },
  {
    id: "stainlist",
    title: "Stains",
    type: "item",
    icon: <Icon.Zap size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/stainlist",

  },
  {
    id: "tcpccenters",
    title: "TCPC Centers",
    type: "item",
    icon: <Icon.Unlock size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tcpccenters",

  },
  {
    id: "tcpcpathologist",
    title: "TCPC Pathologists",
    type: "item",
    icon: <Icon.UserCheck size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tcpcpathologists",

  },
  {
    id: "testgroups",
    title: "Test Groups",
    type: "item",
    icon: <Icon.Umbrella size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/testgroups",

  },
  {
    id: "tests",
    title: "Tests",
    type: "item",
    icon: <Icon.Type size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tests",

  },
  {
    id: "TestPerformedLOINCCode",
    title: "Test Performed LOINC Code",
    type: "item",
    icon: <Icon.Droplet size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/TestPerformedLOINCCode",

  },
  {
    id: "TestOrderedLOINCCode",
    title: "Test Ordered LOINC Code",
    type: "item",
    icon: <Icon.Inbox size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/TestOrderedLOINCCode",

  },
  {
    id: "users",
    title: "Users",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/users",

  },

]

export default optionsMenuConfig